import { useAsyncFn } from '@clara/hooks'
import { http } from '@/lib'

export type MarkAsPaidReimbursement = {
  paymentDate: string
  concept?: string
  reference?: string
  paymentMethod?: string | null
  paymentMethodNote?: string
  note?: string
}

export type MarkAsPaidPayload = {
  reimbursements: MarkAsPaidReimbursement[]
}

export type MarkAsPaidResponse = {
  reimbursementSendToPay: any[]
  errors: {
    uuid: string
    error: string
  }[]
}

async function updateReimbursement(data: MarkAsPaidPayload) {
  return http
    .post<MarkAsPaidResponse>('/mark-as-paid', data)
    .then((res) => res.data)
}

export function useMarkAsPaid() {
  return useAsyncFn(async (data: MarkAsPaidPayload) => {
    const res = await updateReimbursement(data)
    return res
  }, [])
}
